module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modify-checkpoint">\n\n';
 if(rename){ 
__p+='\n  <input type="radio" name="current_mode" class="d-none" value="renaming" checked="checked" />\n  <div class="form-group">\n    <label class="col-form-label" for="updated-master-name">\n      '+
((__t=( I18n.t("utils.rename_master." + type + ".rename_label") ))==null?'':__t)+
'\n    </label>\n    <input type="text" value="'+
((__t=( value.master_name ))==null?'':__t)+
'" id="updated-master-name" class="form-control" />\n  </div>\n  <div class="form-group">\n    <a class="select-or-create">\n      '+
((__t=( I18n.t("utils.rename_master." + type + ".select_or_create") ))==null?'':__t)+
'\n    </a>\n  </div>\n';
 } else { 
__p+='\n  <!-- Select or Create -->\n  ';
 if(!canSelect && !canCreate){ 
__p+='\n    '+
((__t=( I18n.t("utils.rename_master." + type + ".no_choices") ))==null?'':__t)+
'\n    <input type="radio" name="current_mode" class="d-none" value="nothing" checked="checked" />\n  ';
 } else { 
__p+='\n    <!-- Mode selection -->\n    ';
 if(canSelect && canCreate){ 
__p+='\n      <div class="form-group select-type">\n        <div class="form-check">\n          <label class="form-check-label">\n            <input type="radio" name="current_mode" value="select" checked="checked" class="form-check-input">\n            '+
((__t=( I18n.t("utils.rename_master." + type + ".select") ))==null?'':__t)+
'\n            <span class="help-popover" data-bs-container="body" data-bs-trigger="hover"\n                  data-bs-title = "'+
((__t=( I18n.t("utils.rename_master." + type + ".select_help_title") ))==null?'':__t)+
'"\n                  data-bs-content="'+
((__t=( I18n.t("utils.rename_master." + type + ".select_help_content") ))==null?'':__t)+
'">\n              <i class="icon-question-sign"></i>\n            </span>\n          </label>\n        </div>\n        <div class="form-check">\n          <label class="form-check-label">\n            <input type="radio" name="current_mode" value="create" class="form-check-input">\n            '+
((__t=( I18n.t("utils.rename_master." + type + ".create") ))==null?'':__t)+
'\n            <span class="help-popover" data-bs-container="body" data-bs-trigger="hover"\n                  data-bs-title = "'+
((__t=( I18n.t("utils.rename_master." + type + ".create_help_title") ))==null?'':__t)+
'"\n                  data-bs-content="'+
((__t=( I18n.t("utils.rename_master." + type + ".create_help_content") ))==null?'':__t)+
'">\n              <i class="icon-question-sign"></i>\n            </span>\n          </label>\n        </div>\n      </div>\n    ';
 } else if(canSelect) { 
__p+='\n      <input type="radio" name="current_mode" class="d-none" value="select" checked="checked" />\n    ';
 } else { 
__p+='\n      <input type="radio" name="current_mode" class="d-none" value="create" checked="checked" />\n    ';
 } 
__p+='\n    <!-- Form elements -->\n    <div class="form-group select-master">\n      <label class="col-form-label" for="updated-master-name">\n        '+
((__t=( I18n.t("utils.rename_master." + type + ".select_label") ))==null?'':__t)+
'\n      </label>\n      <select id="select-master-id" class="form-select">\n        ';
 _.each(choices, function(master){ 
__p+='\n          <option value='+
((__t=( master.id ))==null?'':__t)+
' data-master-name="'+
((__t=( master.get('name') ))==null?'':_.escape(__t))+
'">\n            '+
((__t=( master.get('name') ))==null?'':_.escape(__t))+
'\n          </option>\n        ';
 }) 
__p+='\n      </select>\n      ';
 if(canIncludeAllCheckpoints){ 
__p+='\n      <div class="form-check">\n        <label class="form-check-label">\n          <input class="form-check-input" type="checkbox" id="include-all-checkpoints">\n          '+
((__t=( I18n.t("utils.rename_master.checklist.include_all_checkpoints") ))==null?'':__t)+
'\n        </label>\n      </div>\n      ';
 } 
__p+='\n    </div>\n    <div class="form-group create-master">\n      <label class="col-form-label" for="new-master-name">\n        '+
((__t=( I18n.t("utils.rename_master." + type + ".new_name_label") ))==null?'':__t)+
'\n      </label>\n      <div class="controls">\n        <input type="text" value="" id="new-master-name" class="form-control"\n               placeholder="'+
((__t=( I18n.t("utils.rename_master." + type + ".new_name_placeholder") ))==null?'':__t)+
'">\n      </div>\n    </div>\n    ';
 if(type=="checkpoint"){ 
__p+='\n    <div class="form-check">\n      <label class="form-check-label">\n        <input class="form-check-input" type="checkbox" id="add-as-independent">\n        '+
((__t=( I18n.t("utils.rename_master.checkpoint.add_as_independent") ))==null?'':__t)+
'\n      </label>\n    </div>\n    ';
 } 
__p+='\n  ';
 } 
__p+='\n';
 } 
__p+='\n</div>\n';
}
return __p;
};
